<div
  *ngIf="
    isPrintStatusBtnVisible &&
    allPrintersList?.length &&
    isRealmNotEnabledAndReactDevice &&
    !isDelayPrintingEnabled
  "
  class="print-status-container"
  (click)="onlyOpenAllPrintersModal()"
>
  <ng-container *ngIf="allPrintersActive; else notActiveTpl">
    <img [src]="images.CONNECTED_ICON" alt="printer-connected" />
  </ng-container>
  <ng-template #notActiveTpl>
    <img
      [src]="images.DISCONNECTED_ICON"
      alt="printer-disconnected"
      [class.zoom-in-out-box]="showAnimation && isShakeEnabled"
    />
  </ng-template>
</div>

<!-- This below section is designed to display only when the delay print setting is enabled from the Retool -->

<div
  *ngIf="
    isPrintStatusBtnVisible &&
    allPrintersList?.length &&
    isRealmNotEnabledAndReactDevice &&
    isDelayPrintingEnabled
  "
  class="print-status-container m-r-10"
  nz-popover
  nzPopoverPlacement="bottom"
  nzPopoverTrigger="click"
  [nzPopoverContent]="contentTemplate"
>
  <div
    class="count ta_center color-white fw-400 lh-140 br-50"
    *ngIf="totalData?.totalCount > 0"
  >
    {{ totalData?.totalCount }}
  </div>
  <img
    class="c-pointer"
    [class.zoom-in-out-box]="
      totalData.totalCount > 0 && showAnimation && isShakeEnabled
    "
    [src]="
      totalData.totalCount === 0
        ? images.CONNECTED_ICON
        : images.DISCONNECTED_ICON
    "
    alt="printer-status-icon"
  />
</div>

<ng-template #contentTemplate>
  <ng-container *ngFor="let card of popoverCardData; let i = index">
    <div
      (click)="performAction(i)"
      class="flex_sb popover-card c-pointer"
      [ngClass]="{
        'no-data-card-bg': card.totalCountData === 0,
        'm-t-10': i > 0
      }"
    >
      <div class="flex_sb">
        <img
          [src]="
            card.totalCountData === 0
              ? card.connectionIconGreen
              : card.connectionIconBlue
          "
          alt="card-icon"
        />
        <div class="vertical-line"></div>
        <div class="popover-row-text">
          <div class="popover-header fw-700 lh-130">
            <ng-container
              *ngIf="card.totalCountData === 0; else titelWithDataTemplate"
            >
              <span class="no-print-events fw-700 lh-130">{{
                card?.noDataTitle
              }}</span>
            </ng-container>
            <ng-template #titelWithDataTemplate>
              <span class="clr-333">{{ card?.dataTitle }}</span>
              <span class="event-count fw-400 lh-130">
                ({{ card?.totalCountData }})
              </span>
            </ng-template>
          </div>
          <div class="popover-description fw-400 lh-140 clr-666">
            {{
              card.totalCountData === 0
                ? card?.noDataDescription
                : card?.dataDescription
            }}
          </div>
        </div>
      </div>
      <div>
        <img
          [src]="
            card.totalCountData === 0
              ? card.actionIconGreen
              : card.actionIconBlue
          "
          alt="card-icon"
          alt="right-arrow"
        />
      </div>
    </div>
  </ng-container>
</ng-template>
